export const SET_PREVIEW_PHOTO = 'SET_PREVIEW_PHOTO';
export const SET_ANALYSIS_RESULT = 'SET_ANALYSIS_RESULT';
export const SET_GUIDANCE_VISIBILITY = 'SET_GUIDANCE_VISIBILITY';
export const SET_PHOTO_UPLOADED = 'SET_PHOTO_UPLOADED';
export const SET_PHOTO_PREVIEW_ZOOM = 'SET_PHOTO_PREVIEW_ZOOM';
export const SET_PHOTO_PREVIEW_OFFSET = 'SET_PHOTO_PREVIEW_OFFSET';

export const TAKE_PHOTO_SAGA = 'TAKE_PHOTO_SAGA';
export const UPLOAD_PHOTO_SAGA = 'UPLOAD_PHOTO_SAGA';

export const RESET_PHOTO_STATE_ACTION = 'RESET_PHOTO_STATE_ACTION';

export const PHOTO_TYPE_FACE = 'face';
export const PHOTO_TYPE_TONGUE = 'tongue';

export const setPreviewPhotoAction = ({ src, photoType }) => ({
  type: SET_PREVIEW_PHOTO,
  src,
  photoType,
});

export const takePhotoAction = ({ photoType, next }) => ({
  type: TAKE_PHOTO_SAGA,
  photoType,
  next,
});

export const takeFacePhotoAction = next =>
  takePhotoAction({ next, photoType: PHOTO_TYPE_FACE });
export const takeTonguePhotoAction = next =>
  takePhotoAction({ next, photoType: PHOTO_TYPE_TONGUE });

const uploadPhotoAction = ({ photoType, next }) => ({
  type: UPLOAD_PHOTO_SAGA,
  photoType,
  next,
});

export const uploadFacePhotoAction = next =>
  uploadPhotoAction({ next, photoType: PHOTO_TYPE_FACE });

export const uploadTonguePhotoAction = next =>
  uploadPhotoAction({ next, photoType: PHOTO_TYPE_TONGUE });

export const setPhotoAnalysisResult = ({ photoType, unrecognizable }) => ({
  type: SET_ANALYSIS_RESULT,
  photoType,
  unrecognizable,
});

export const setGuidanceVisibility = ({ photoType, on = false }) => ({
  type: SET_GUIDANCE_VISIBILITY,
  on,
  photoType,
});

export const setPhotoUploaded = ({ photoType, uploaded = true }) => ({
  type: SET_PHOTO_UPLOADED,
  uploaded,
  photoType,
});

export const setPhotoPreviewZoom = ({ photoType, zoom, last = false }) => ({
  type: SET_PHOTO_PREVIEW_ZOOM,
  photoType,
  zoom,
  last,
});

export const setPhotoPreviewOffset = ({
  photoType, x, y, last = false
}) => ({
  type: SET_PHOTO_PREVIEW_OFFSET,
  photoType,
  x,
  y,
  last,
});

export const resetPhotoStateAction = ({ photoType }) => ({
  type: RESET_PHOTO_STATE_ACTION,
  photoType,
});



// WEBPACK FOOTER //
// ./src/actions/photo.js